module.exports = __webpack_public_path__ + "static/media/5.560b5c26.jpg";